<template>
  <v-row class="d-flex mb-10">
    <v-col cols="12">
      <v-card v-if="isXs" class="rounded-lg pt-4 pb-4 white">
        <v-row>
          <v-col cols="4">
            <v-avatar v-if="!user.profile_picture" size="90" class="rounded-lg mr-4" color="#FFACC5">
              <v-img
                  @click="$router.push('/panel/profile')"
                  src="/img/icons/profile_dark.svg"
                  max-width="80"
                  max-height="80"
              ></v-img>
            </v-avatar>
            <v-avatar class="rounded-lg mr-4" v-else size="90">
              <v-img class="rounded-lg" :src="img_source(user.profile_picture)" />
            </v-avatar>
          </v-col>
          <v-col cols="8" class="d-flex justify-center pt-10">
            <strong class="secondary--text  mb-5">
              سلام
              {{ user.name }}
            </strong>
          </v-col>
        </v-row>
      </v-card>
      <v-card v-if="!isXs" class="rounded-lg pt-4 pb-4" :style="'border: 1px solid white;'">
        <v-row class="mr-1 ml-1">
          <v-col cols="12" md="1" class="justify-sm-center pr-4">
            <v-img v-if="!user.profile_picture" contain max-height="134" max-width="134" src="/img/user.png" />
            <v-avatar v-if="user.profile_picture" size="100">
              <v-img class="rounded-lg" :src="img_source(user.profile_picture)" />
            </v-avatar>
          </v-col>
          <v-col cols="12" md="8" class="mt-6 justify-start">
            <v-row>
              <strong :style="{ color: '#080707' }" class="mr-5 mt-7">
                {{ user.name }}
              </strong>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="rounded-lg mt-7 pt-4 pb-4" :style="'border: 1px solid white;'">
        <v-tabs v-model="openTab" color="#590d22">
          <v-tab class="mr-2">
            <span>مشخصات کاربری</span>
          </v-tab>
          <v-tab>
            <span>تغییر کلمه عبور</span>
          </v-tab>
          <v-tab-item>
            <v-card flat class="mt-5" :style="'border: 1px solid white;'">
              <v-card-text>
                <v-form ref="form">
                  <row>
                    <v-col cols="12" md="4" class="mt-5 mb-5">
                      <m-file-input
                        label="عکس پروفایل"
                        :disabled="!isEditing"
                        v-model="item.profile_picture"
                        :delete-attachment.sync="item.delete_profile_picture"
                      />
                    </v-col>
                  </row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        class="rounded-lg"
                        label=" * نام"
                        v-model="item.first_name"
                        :disabled="!isEditing"
                        :rules="rules.required"
                        :hide-details="false"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        class="rounded-lg"
                        label="* نام خانوادگی"
                        v-model="item.last_name"
                        :disabled="!isEditing"
                        :rules="rules.required"
                        :hide-details="false"
                      />
                    </v-col>

                    <v-col cols="12" md="6">
                      <mobile class="rounded-lg" label="* شماره موبایل " v-model="item.phone" :disabled="true" />
                    </v-col>
                    <v-col cols="12" md="6">
                      <m-national-code class="rounded-lg" label="* کد ملی " v-model="item.username" :disabled="true" />
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed class="rounded-lg" @click="accept_dialog = true" color="secondary white--text"
                  >تغییر شماره موبایل
                </v-btn>
                <template v-if="!isEditing">
                  <v-btn depressed @click="isEditing = true" class="warning rounded-lg white--text w-100px"
                    >ویرایش
                  </v-btn>
                </template>
                <template v-else>
                  <v-btn depressed @click="updateProfile" color="success white--text w-100px" class="rounded-lg"
                    >ثبت
                  </v-btn>
                </template>
              </v-card-actions>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat class="mt-5" :style="'border: 1px solid white;'">
              <v-card-text>
                <v-form ref="changePasswordForm">
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        class="text-field-ltr rounded-lg"
                        label=" * کلمه عبور فعلی"
                        :type="pass_type"
                        v-model="oldPassword"
                        :rules="rules.required"
                        :append-icon="pass_icon"
                        :hide-details="false"
                        @click:append="changeType"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        class="text-field-ltr rounded-lg"
                        label=" * کلمه عبور جدید"
                        :type="pass1_type"
                        v-model="newPassword"
                        :rules="passwordRules"
                        :append-icon="pass1_icon"
                        :hide-details="false"
                        @click:append="changeType1"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        class="text-field-ltr rounded-lg"
                        :type="pass2_type"
                        label=" * تکرار کلمه عبور جدید"
                        v-model="newPasswordRepeat"
                        :rules="rules.required"
                        :hide-details="false"
                        :append-icon="pass2_icon"
                        @click:append="changeType2"
                      />
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="changePassword" color="success white--text w-100px" depressed class="rounded-lg"
                  >ثبت
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-col>
    <v-row justify="center">
      <v-dialog
        v-model="accept_dialog"
        class="rounded-lg"
        persistent
        @click:outside="accept_dialog = false"
        max-width="400"
      >
        <v-card class="rounded-lg">
          <v-card-title class="secondary white--text"> توجه! </v-card-title>
          <v-card-text class="mt-5"> آیا از تغییر شماره موبایل اطمینان دارید؟ </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="rounded-lg" color="error" depressed @click="accept_dialog = false"> خیر </v-btn>
            <v-btn @click="sendVerifyCode" depressed class="rounded-lg" color="success white--text">بله </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>


    <v-dialog v-model="codeVerified" scrollable max-width="500px" transition="dialog-transition">
      <v-card class="rounded-lg pa-2">
        <v-card-title class="secondary--text">تغییر شماره موبایل</v-card-title>

        <v-card-text>
          <v-form ref="changePhoneForm">
            <v-row class="mt-2">
              <v-col cols="12" :md="codeSent ? 12 : 8">
                <mobile class="rounded-lg" color="secondary" label="* شماره موبایل جدید" v-model="newPhone" />
              </v-col>
              <v-col cols="12" md="12">
                <v-btn
                  block
                  depressed
                  color="success white--text"
                  class="mt-2 rounded-lg"
                  @click="sendVerificationCodeWithPhone"
                >
                  ارسال کد
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="verify_dialog"
      class="rounded-lg"
      persistent
      @click:outside="verify_dialog = true"
      max-width="600"
    >
      <v-card class="rounded-lg">
        <v-card-title class="secondary white--text text-h6">
          <v-icon class="white--text ml-2">fa-check</v-icon>
          کد تایید برای شماره موبایل {{ phone_sample }} ارسال شد
          <v-spacer></v-spacer>
          <v-icon left @click="verify_dialog = false" class="primary--text">fa-times</v-icon>
        </v-card-title>
        <v-card-text class="text-center mt-5">
          <v-row class="mt-5 mr-3 ml-3">
            <v-text-field
              v-if="!change_phone"
              class="text-field-ltr rounded-lg"
              label="کد دریافت شده"
              v-model="code"
              :rules="rules.required"
            />
            <v-text-field
              v-if="change_phone"
              class="text-field-ltr rounded-lg"
              label="کد دریافت شده"
              v-model="new_code"
              :rules="rules.required"
            />
          </v-row>
          <v-row class="text-center">
            <v-col cols="12" md="12" class="text-center">
              <span> شما می توانید پس از </span>
              <span class="justify-center ml-2 mr-2"> {{ count_seconds }} : {{ count_minute }} </span>
              <span> مجددا درخواست پیامک بدهید </span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="timerCount > 0"
            @click="sendVerifyCode"
            depressed
            color="secondary"
            class="white--text rounded-lg ml-1"
            outlined
          >
            <v-img
              v-if="timerCount <= 0"
              src="/img/icons/reload.svg"
              max-width="20"
              max-height="20"
              class="ml-2"
            ></v-img>
            ارسال دوباره کد
          </v-btn>
          <v-btn
            v-if="!change_phone"
            :disabled="code == null"
            @click="checkVerificationCode(code)"
            depressed
            color="success"
            class="white--text rounded-lg"
            >تایید کد
          </v-btn>
          <v-btn
            large
            v-if="change_phone"
            :disabled="code == null"
            @click="changePhone(code)"
            depressed
            color="success"
            class="white--text rounded-lg"
          >
            تایید کد و تغییر شماره همراه
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { MFormMixin } from "@/components/m-form";
import UserApi from "@/views/panel/user/api";
import GetUserApi from "@/views/panel/user/getUserApi";
import AuthMixin from "@/views/auth/mixin";
import MDatatable from "@/components/m-datatable";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import Template from "../Template.vue";
import mobile from "@/components/scomponents/Mobile";

export default {
  components: { MDatatable, VueQrcode, Template, mobile },
  name: "Register",
  mixins: [AuthMixin, MFormMixin, UserApi, GetUserApi],
  props: {},
  data() {
    return {
      isEditing: false,
      openTab: 0,

      oldPassword: null,
      newPassword: null,
      newPasswordRepeat: null,

      invitations: [],
      pass1_type: "password",
      pass2_type: "password",
      pass1_icon: "fa-eye",
      pass2_icon: "fa-eye",
      pass_type: "password",
      pass_icon: "fa-eye",

      invitation: null,
      confirmInvitationDialog: false,
      confirmationCode: null,

      secretKey: {},
      removeSecretKeyDialog: false,

      changePhoneDialog: false,
      newPhone: "",
      phoneVerificationCode: null,
      codeSent: false,
      change_phone: false,
      accept_dialog: false,
      canResend: false,
      timer: 0,
      code: null,
      new_code: null,
    };
  },
  computed: {
    title() {
      return this.setDocumentTitle("مشخصات کاربر");
    },
  },
  mounted() {
    this.setItem(this.user);
  },
  methods: {
    sendVerifyCode() {
      this.accept_dialog = false;
      this.sendVerificationCode(
        {
          username: this.user.username,
          recaptchaResponse: this.recaptchaResponse,
        },
        () => ((this.codeSent = true), (this.verify_dialog = true))
      );
    },
    sendVerificationCodeWithPhone() {
      this.codeVerified = false;
      this.request({
        url: this.endpoint("users/sendVerificationCode"),
        method: "post",
        data: {
          username: this.user.username,
          phone: this.newPhone,
        },
        token: false,
        success: (data) => {
          this.$refs.recaptcha && this.$refs.recaptcha.reset();
          this.verify_dialog = true;
          this.phone_sample = data.phone_sample;
          this.notify("کد تایید ارسال شد", "success");
          this.timerCount = 300;
          this.timerEnabled = true;
          this.change_phone = true;
        },
        error: (error) => {
          this.$refs.recaptcha && this.$refs.recaptcha.reset();
          this.handleError(error, {});
        },
      });
    },

    sendCode() {
      if (this.$refs.changePhoneForm.validate()) {
        this.sendVerificationCode(
          {
            username: this.user.username,
          },
          () => (this.codeSent = true)
        );
      }
    },
    changePhone() {
      this.request({
        url: this.endpoint(`users/changePhoneByVerificationCode`),
        method: "post",
        data: {
          new_phone: this.newPhone,
          username: this.user.username,
          verificationCode: this.new_code,
        },
        success: (data) => {
          this.notify("شماره تماس تغییر کرد", "success");
          this.item.phone = this.newPhone;
          this.changePhoneDialog = false;
          this.newPhone = undefined;
          this.verify_dialog = false;
          this.phoneVerificationCode = undefined;
          this.codeSent = false;
        },
      });
    },
    openChangePhoneDialog() {
      this.changePhoneDialog = true;
    },
    setSecretKey() {
      this.request({
        url: this.endpoint(`users/secretKey`),
        method: "put",
        data: {
          secret_key: this.secretKey.secret_key,
          code: this.secretKey.code,
        },
        success: (data) => {
          this.secretKey.code = null;
          this.successNotify();
          this.getUser();
        },
      });
    },
    removeSecretKey() {
      this.request({
        url: this.endpoint(`users/secretKey`),
        method: "delete",
        data: {
          code: this.secretKey.code,
        },
        success: () => {
          this.removeSecretKeyDialog = false;
          this.successNotify();
          this.getSecretKey();
          this.getUser();
        },
      });
    },
    getSecretKey() {
      this.request({
        url: this.endpoint(`users/secretKey`),
        method: "get",
        success: (data) => {
          this.secretKey = data;
        },
      });
    },
    updateProfile() {
      this.request({
        url: this.endpoint(`users/update/${this.item.id}`),
        method: "put",
        data: this.getUpdateSerialized(),
        success: (data) => {
          this.successNotify();
          this.isEditing = false;
          window.location.reload();
        },
      });
    },
    changePassword() {
      if (this.$refs.changePasswordForm.validate()) {
        if (this.newPassword != this.newPasswordRepeat) {
          this.notify("کلمه عبور و تکرار آن یکسان نیستند", "danger");
          return;
        }
        this.request({
          url: this.endpoint(`users/changePassword`),
          method: "post",
          data: {
            old_password: this.oldPassword,
            new_password: this.newPassword,
          },
          success: (data) => {
            this.successNotify();
            this.oldPassword = null;
            this.newPassword = null;
            this.newPasswordRepeat = null;
            this.openTab = 0;
          },
        });
      }
    },
    confirmInvitation(invitation) {
      this.invitation = invitation;
      this.confirmInvitationDialog = true;
    },
    changeInvitationStatus(item, status, confirmationCode = null) {
      this.request({
        url: this.endpoint(`users/invitations/changeStatus`),
        method: "post",
        data: {
          id: item.id,
          status: status,
          confirmation_code: confirmationCode,
        },
        success: () => {
          this.confirmInvitationDialog = false;
          this.confirmationCode = null;
          this.successNotify();
          this.getInvitations();
        },
      });
    },
    getInvitations() {
      this.request({
        url: this.endpoint(`users/invitations`),
        method: "get",
        success: (data) => {
          this.invitations = data;
        },
      });
    },
    changeType1() {
      if (!this.pass1_type) {
        this.pass1_type = "password";
        this.pass1_icon = "fa-eye";
      } else {
        this.pass1_type = "";
        this.pass1_icon = "fa-eye-slash ";
      }
    },
    changeType2() {
      if (!this.pass2_type) {
        this.pass2_type = "password";
        this.pass2_icon = "fa-eye";
      } else {
        this.pass2_type = "";
        this.pass2_icon = "fa-eye-slash ";
      }
    },
    changeType() {
      if (!this.pass_type) {
        this.pass_type = "password";
        this.pass_icon = "fa-eye";
      } else {
        this.pass_type = "";
        this.pass_icon = "fa-eye-slash ";
      }
    },
    getSerialized() {
      let item = this.copy(this.item);

      if (typeof item["profile_picture"] == typeof "") {
        delete item["profile_picture"];
      }

      return this.jsonToFormData(item);
    },
    getUpdateSerialized() {
      let item = {
        profile_picture: this.item.profile_picture,
        delete_profile_picture: this.item.delete_profile_picture,
        first_name: this.item.first_name,
        last_name: this.item.last_name,
      };

      if (typeof item["profile_picture"] == typeof "") {
        delete item["profile_picture"];
      }

      return this.jsonToFormData(item);
    },
  },
};
</script>
